import React from 'react';
import './ParentDashboardSkeleton.css';

function SkeletonBlock({ width, height, borderRadius }) {
  return (
    <div
      className="parent-skeleton__block"
      style={{ width, height, borderRadius: borderRadius || '8px' }}
    />
  );
}

function ParentDashboardSkeleton() {
  return (
    <div className="parent-skeleton" aria-label="Loading dashboard" role="status">
      {/* Header skeleton */}
      <div className="parent-skeleton__header">
        <SkeletonBlock width="200px" height="28px" borderRadius="6px" />
        <SkeletonBlock width="140px" height="16px" borderRadius="4px" />
      </div>

      {/* Summary text */}
      <SkeletonBlock width="100%" height="48px" borderRadius="10px" />

      {/* Summary cards row */}
      <div className="parent-skeleton__cards">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="parent-skeleton__card">
            <SkeletonBlock width="60%" height="14px" />
            <SkeletonBlock width="40%" height="24px" />
            <SkeletonBlock width="80%" height="12px" />
          </div>
        ))}
      </div>

      {/* Alert section */}
      <div className="parent-skeleton__section">
        <SkeletonBlock width="180px" height="20px" borderRadius="6px" />
        <div className="parent-skeleton__alerts">
          {[1, 2, 3].map(i => (
            <div key={i} className="parent-skeleton__alert">
              <SkeletonBlock width="100%" height="72px" borderRadius="12px" />
            </div>
          ))}
        </div>
      </div>

      {/* Course section */}
      <div className="parent-skeleton__section">
        <SkeletonBlock width="160px" height="20px" borderRadius="6px" />
        <div className="parent-skeleton__courses">
          {[1, 2, 3].map(i => (
            <div key={i} className="parent-skeleton__course">
              <SkeletonBlock width="100%" height="100px" borderRadius="12px" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ParentDashboardSkeleton;
